import fulfill from '../../fulfill';
import { CORE_API_HOSTNAME } from '../../env';
import { SideEffectFunction } from '../../sideEffects';
import { ActionTypes, FetchDiscounts, FetchDiscountsResponse, FetchNextDiscountResponse } from './actions';
import { Campaign, Discount } from '../../types/discounts';
import { FetchCampaigns, FetchCampaignsResponse } from '../campaignsLists/actions';

export const fetchDiscounts: SideEffectFunction<FetchDiscounts, FetchDiscountsResponse> = async action => {
    const params = action.payload.params;
    params.set('include', 'statistics');
    const result: FetchDiscountsResponse = await fulfill.get({
        accountId: action.payload.accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${action.payload.accountId}/discounts/rules?${params.toString()}`,
        handlers: {
            200: (discounts: Discount[]) => ({
                type: ActionTypes.FetchDiscountsResponse,
                payload: {
                    discounts,
                },
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

export const fetchNext: SideEffectFunction<FetchDiscountsResponse, FetchNextDiscountResponse> = async action => {
    const hasLimitInParams = action.meta.cause.payload.params.get('limit');
    const isAtLastPage = hasLimitInParams
        ? action.payload.discounts.length < parseInt(hasLimitInParams)
        : action.payload.discounts.length === 0;
    if (isAtLastPage) {
        return {
            type: ActionTypes.FetchNextDiscountResponse,
            payload: {
                discounts: [],
            },
            meta: {
                cause: action,
            },
        };
    }
    const accountId = action.meta.cause.payload.accountId;
    const result: FetchNextDiscountResponse = await fulfill.get({
        accountId: accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/discounts/rules?limit=1&include=statistics`,
        handlers: {
            200: (discounts: Discount[]) => ({
                type: ActionTypes.FetchNextDiscountResponse,
                payload: { discounts },
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

export const fetchCampaigns: SideEffectFunction<FetchCampaigns, FetchCampaignsResponse> = async action => {
    const result: FetchCampaignsResponse = await fulfill.get({
        accountId: action.payload.accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${action.payload.accountId}/discounts/campaigns?limit=100`,
        handlers: {
            200: (campaigns: Campaign[]) => ({
                type: ActionTypes.FetchCampaignsResponse,
                payload: {
                    campaigns,
                },
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

const effects = {
    [ActionTypes.FetchDiscounts]: [fetchDiscounts],
    [ActionTypes.FetchCampaigns]: [fetchCampaigns],
    [ActionTypes.FetchDiscountsResponse]: [fetchNext],
};

export default effects;
